module.exports = __webpack_public_path__ + "img/more.94258d4c.png";